'use es6';

import { useEffect, useRef, useCallback } from 'react';
import { tracker } from '../_core/common/eventTracking/tracker';
import { getFrameSrc, getUpgradePointPromise, getTrackingProperties, upgradePointViews } from './utils';
import { useModalFrame } from '../useModalFrame';
import { LoadingModal } from 'ui-addon-upgrades/_core/common/components/LoadingModal';
export function useUpgradeModal(upgradeKey) {
  var upgradeKeyRef = useRef(upgradeKey);
  var frameSrc = useRef(getFrameSrc(upgradeKeyRef.current));
  var upgradePointPromise = useRef(getUpgradePointPromise(upgradeKeyRef.current));

  var _useModalFrame = useModalFrame({
    id: 'ui-addon-upgrade-modal-frame',
    src: frameSrc.current,
    renderLoadingModal: LoadingModal
  }),
      setLoadFrame = _useModalFrame.setLoadFrame; // Fetch upgrade config and track view


  useEffect(function () {
    upgradePointPromise.current.then(function (upgradePoint) {
      if (!upgradePointViews[upgradeKeyRef.current]) {
        upgradePointViews[upgradeKeyRef.current] = true;
        tracker.track('interaction', Object.assign({
          action: 'viewed upgrade point'
        }, getTrackingProperties(upgradePoint)));
      }
    }).done();
  }, []); // Track click and set state

  var openUpgradeModal = useCallback(function () {
    setLoadFrame(true);
    upgradePointPromise.current.then(function (upgradePoint) {
      tracker.track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, getTrackingProperties(upgradePoint)));
    }).done();
  }, [setLoadFrame]);
  return {
    openUpgradeModal: openUpgradeModal
  };
}